import axios from 'axios'
import Config from './Config'

let instance = axios.create({
    baseURL: Config.baseURL,
    headers: {
        'Content-Type': 'application/json',
        "accept": 'application/json'
    },
})

instance.interceptors.request.use(async function (Config) {
    try {
        const token = localStorage.getItem('token')
        
        if (token) {
            Config.headers.Authorization = token
        }
        return Config
    } catch {
        return Config
    }
})

export default instance